var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"watchlist"},[_c('ith-top-bar'),_c('ith-banner',{attrs:{"item":_vm.banner}}),_c('ith-sad-top'),_c('ith-watchlist-grid'),_c('ith-sad-bottom'),_c('ith-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }